import { render, staticRenderFns } from "./ProductMgmt.vue?vue&type=template&id=9a76896a&scoped=true"
import script from "./ProductMgmt.vue?vue&type=script&lang=js"
export * from "./ProductMgmt.vue?vue&type=script&lang=js"
import style0 from "./ProductMgmt.vue?vue&type=style&index=0&id=9a76896a&prod&lang=scss"
import style1 from "./ProductMgmt.vue?vue&type=style&index=1&id=9a76896a&prod&lang=css"
import style2 from "./ProductMgmt.vue?vue&type=style&index=2&id=9a76896a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a76896a",
  null
  
)

export default component.exports